import { Product } from "./types";

function sortProducts(products: Product[]) {
  function categoryCompare(a: Product, b: Product) {
    if (
      (a.category === "checking" && b.category !== "checking") ||
      (a.category === "savings" &&
        ["certificate_of_deposit", "money_market"].includes(b.category)) ||
      (a.category === "money_market" && b.category === "certificate_of_deposit")
    ) {
      return -1;
    }
    if (
      (b.category === "checking" && a.category !== "checking") ||
      (b.category === "savings" &&
        ["certificate_of_deposit", "money_market"].includes(a.category)) ||
      (b.category === "money_market" && a.category === "certificate_of_deposit")
    ) {
      return 1;
    }
    return 0;
  }
  return products.sort((a, b) => {
    if (a.category === b.category) {
      return a.display_order - b.display_order;
    }
    return categoryCompare(a, b);
  });
}

export const getCanImport = (uatProducts: Product[], products: Product[]) => {
  if (!uatProducts?.length) {
    return false;
  }
  if (uatProducts.length !== products.length) {
    return true;
  }
  const orderedProducts = sortProducts(products);
  return uatProducts.some((uatProduct, index) => !isEqual(uatProduct, orderedProducts[index]));
};

export function isEqual(x: any, y: any): boolean {
  const ok = Object.keys,
    tx = typeof x,
    ty = typeof y;
  return x && y && tx === "object" && tx === ty
    ? ok(x).length === ok(y).length && ok(x).every((key) => isEqual(x[key], y[key]))
    : x === y;
}

export function isEmpty(value: any): boolean {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0)
  );
}

/**
 * Validates a monthly service fee value.
 * Accepts any text (numeric or non-numeric) up to 120 characters.
 * @param value - The value to validate
 * @returns Empty string if valid, error message if invalid
 */
export const validateMonthlyServiceFee = (value: string | null | undefined): string => {
  if (!value) {
    return "";
  }

  const trimmed = typeof value === "string" ? value.trim() : "";

  if (!trimmed) {
    return "";
  }

  if (trimmed.length > 120) {
    return "Exceeds character limits";
  }

  return "";
};
